import { login, useAuth } from '@pesto/features';
import { EnvBadge } from '@pesto/ui/components/EnvBadge';
import { PestoWordmark } from '@pesto/ui/components/PestoWordmark';
import { LoginScreen } from '@pesto/ui/features/LoginScreen/LoginScreen';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { getEnvBadgeConfig } from '../constants/global-env';
import { routes } from '../constants/routes';

export const Login = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated, sendSmsCode, verifySmsCode, codeLoading } = useAuth();

  const authErrorMessage =
    searchParams.get(login.AUTH_CALLBACK_ERROR_QUERY_PARAM) === 'callback_failed'
      ? 'Sign-in could not be completed. Please try again.'
      : null;

  const handleEmailSubmit = (phoneNumber: string) => {
    return sendSmsCode(phoneNumber)
      .then(() => undefined)
      .catch((err: { description: string }) => {
        console.error('Error sending passcode:', err);
        throw err;
      });
  };

  const handleVerificationCodeSubmit = (phoneNumber: string, code: string) => {
    return verifySmsCode(phoneNumber, code)
      .then(() => undefined)
      .catch((err: { description: string }) => {
        console.error('Error parsing hash:', err);
        throw err;
      });
  };

  return (
    <div className="relative">
      {authErrorMessage && (
        <div className="absolute left-1/2 top-4 z-10 w-[calc(100%-2rem)] max-w-xl -translate-x-1/2 rounded-md border border-destructive/20 bg-destructive/10 px-4 py-3 text-sm text-destructive shadow-sm">
          {authErrorMessage}
        </div>
      )}
      <LoginScreen
        logo={
          <div className="mx-auto flex flex-col items-center gap-2">
            <EnvBadge config={getEnvBadgeConfig()} />
            <PestoWordmark className="text-accent h-12 w-auto" />
          </div>
        }
        title="Partner Control"
        codeLoading={codeLoading}
        isAuthenticated={isAuthenticated}
        navigate={navigate}
        redirectPath={routes.dashboard}
        sendSmsCode={handleEmailSubmit}
        verifySmsCode={handleVerificationCodeSubmit}
      />
    </div>
  );
};
